module.exports = __webpack_public_path__ + "components/star-rating/static/white/0.25-b515c4545bfb193252a4f918495da59b.svg";